export default __webpack_public_path__ + "static/media/main2.69068fb6.png";